import { render } from "./EyeBlock.vue?vue&type=template&id=5d27f28a"
import script from "./EyeBlock.vue?vue&type=script&lang=js"
export * from "./EyeBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__